import Vue from 'vue';
import App from './App'
import router from './router';
import Amplify from '@aws-amplify/core';
import aws_exports from './aws-exports';
import Vuetify from 'vuetify'
import axios from 'axios'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, axios)

Vue.config.productionTip = false

Amplify.configure(aws_exports)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App
  }
})
